import React, {Component} from 'react';
import {Form, actions, Errors} from 'react-redux-form';
import {connect} from 'react-redux';
import {Button, Grid, Row, Col} from 'react-bootstrap';
import ErrorMessages from '../../login/error-messages'
import PageTitle from "../../common/page-title/index";
import ArrowButton from "../../common/button-arrow";
import RequiredPasswordMaskInput from "../../common/form/elements/required-password-mask-input";
import {adminUpdateMyPassword} from '../../../actions/update-password';

import './update-password.css'

class UpdatePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    updateErrors = (field, value) => {
        this.setState({[field]: value});
    };

    onChangeMyPasswordClicked = (payload) => {
        this.props.dispatch(actions.submitFields('deep.updatePw.user', adminUpdateMyPassword(payload)));
    };

    render() {
        return (
            <Form
                model="deep.updatePw.user"
                onSubmit={(payload) => this.onChangeMyPasswordClicked(payload)}>
                <Errors
                    className="errors"
                    model="deep.updatePw.user"
                    component={ErrorMessages}
                    show={{touched: true, focus: false}}/>
                <Grid fluid className="update-password">
                    <Row>
                        <Col lg={12}>
                            <PageTitle>Update password</PageTitle>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <RequiredPasswordMaskInput
                              model=".current_password"
                              label="Current Password"
                              controlId="currentPassword"/>

                            <h5>
                                The password must be a minimum of 8 characters and contain one uppercase, one
                                lowercase, one number and one symbol (e.g.@*&/).
                            </h5>
                            <RequiredPasswordMaskInput
                              model=".password"
                              label="New Password"
                              controlId="newPassword"/>

                            <RequiredPasswordMaskInput
                              model=".password_confirmation"
                              label="Confirm New Password"
                              controlId="confirmNewPassword"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <ArrowButton color="red"
                                         className="pull-right"
                                         arrow={false}>Change my password</ArrowButton>
                        </Col>
                    </Row>
                </Grid>
            </Form>
        );
    }
}

export default connect()(UpdatePassword);


// WEBPACK FOOTER //
// ./src/components/admin/update-password/index.jsx